import type { CommonAction } from "@iflyrpa/share";
import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";
import { executeAction } from "../../utils";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";
import { rpaAction_Server } from "./rpa-server";

export const DouyinPublishParamsSchema = ActionCommonParamsSchema.extend({
    title: z.string(), // 标题
    content: z.string(), // 正文("标题。正文")
    textExtra: z.string(),
    topic: z
        .array(
            z.object({
                cha_name: z.string(),
                cid: z.string(),
                view_count: z.string().optional(),
                group_id: z.string().optional(),
                tag: z.number().optional(),
                state: z.string().optional(),
            }),
        )
        .optional(), // 话题
    coverImage: z.string().optional(), // 封面图片
    banners: z.array(z.string()), // 图片URL字符串数组
    mix: z
        .object({
            mix_id: z.string(),
            mix_order: z.number(),
            mix_name: z.string().optional(),
            mix_order_name: z.string().optional(),
        })
        .optional(), //合集id 合集的顺序 合集名称 合集集数名称
    musicId: z.string().optional(), // 音乐Id
    musicName: z.string().optional(), // 音乐名称
    musicAuthor: z.string().optional(), // 音乐作者
    musicDuration: z.number().optional(), // 音乐时长
    challengeIds: z.string().optional(), // 话题Ids的cid字符串数组
    // hashtagSource: z.string(),
    hotSentence: z.string().optional(), // 热点
    proxyLoc: z.string().optional(), // 代理位置
    localIP: z.string().optional(), // 用户ip
    visibleRange: z.enum(["0", "1", "2"]).optional(), // 可见范围 0-公开 1-仅自己可见 2-好友可见
    isImmediatelyPublish: z.boolean().optional(), // 是否立即发布
    scheduledPublish: z.number().optional(), // 定时发布时间，时间戳类型
    allowSave: z.boolean().optional(), // 是否允许保存 保存权限,
    publishType: z.enum(["1", "2", "3", "4"]).optional(), // 发布类型 1：发布视频 2：发布图文 3：发布全景视频 4：发布文章
    extraParam: z.object({
        "security-sdk/s_sdk_pri_key": z.string(), // 必填
        "security-sdk/s_sdk_pub_key": z.string(), // 必填
        "security-sdk/s_sdk_sign_data_key/web_protect": z.string(), // 必填
        "security-sdk/s_sdk_crypt_sdk": z.string(), // 必填
        "security-sdk/s_sdk_server_cert_key": z.string(), // 必填
        browserInfo: z.object({
            screen_width: z.string(),
            screen_height: z.string(),
            browser_language: z.string(),
            browser_platform: z.string(),
            browser_name: z.string(),
            "sec-ch-ua-platform": z.string(),
            "sec-ch-ua": z.string(),
            userAgent: z.string().optional(),
        }),
    }),
    uploadedImgList: z.string().optional(), // 已上传图片列表，JSON字符串格式，数组元素为图片URL
});

export type DouyinPublishParams = z.infer<typeof DouyinPublishParamsSchema>;

export type PublishAction = CommonAction<DouyinPublishParams, string>;

export const douyinPublish: PublishAction = async (task, params) => {
    task.logger.info(`douyinPublish actionType: ${params.actionType}`);
    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    if (params.actionType === "server") {
        return rpaAction_Server(task, params);
    }

    // 优先执行Mock+RPA方案，失败则进入RPA-Server方案
    return executeAction(mockAction, rpaAction)(task, params);
};
